module.exports = __webpack_public_path__ + "static/media/baby-blocks-food.2b29b08e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/baby-blocks-food.jpg
// module id = 822
// module chunks = 0